const ApiResponseCodes = {
  SEND_STORE_ID: "__send_store_id__",
  OK: "__ok__",
};
export { ApiResponseCodes };
